// Words for report screens and prints (DESIGN.md §9: sentence case, plain words).
import type { AGEING_BUCKETS, ServiceItemCategory } from '@wodi/domain';

/** "Department" is the item category until departments exist (finance decision 16, P2). */
export const CATEGORY_LABELS: Record<ServiceItemCategory, string> = {
  consultation: 'Consultation',
  procedure: 'Procedures',
  lab_test: 'Lab tests',
  imaging: 'Imaging',
  medicine: 'Medicines',
  consumable: 'Consumables',
  bed_day: 'Bed days',
  nursing: 'Nursing',
  mortuary: 'Mortuary',
  other: 'Other',
};

export const AGEING_LABELS: Record<(typeof AGEING_BUCKETS)[number], string> = {
  days_0_30: '0 to 30 days',
  days_31_60: '31 to 60 days',
  days_61_90: '61 to 90 days',
  days_over_90: 'Over 90 days',
};

export function plural(count: number, one: string, many: string): string {
  return `${String(count)} ${count === 1 ? one : many}`;
}
